function ScadawtpRoute() {
  return (
    <div>
      <div style={{ width: "100%", height: "100%" }}>
        <iframe
          src="/scadawtp.html" // your HTML file in public folder
          title="scadawtp"
          width="100%"
          height="800px"
          style={{ border: "none" }}
        />
      </div>
    </div>
  );
}

export default ScadawtpRoute;